import React from "react";
import MaButton from "../../../../Components/UI/ma-button";

const btnSx = {
  bgcolor: "#FFFFFF",
  color: "#374151",
  border: "1px solid #E5E7EB",
  boxShadow: "none",
  minHeight: "40px",
  minWidth: "100px",
  borderRadius: "10px",
  fontWeight: 600,
  fontSize: "13px",
  textTransform: "none",
  "&:hover": {
    bgcolor: "#F9FAFB",
    borderColor: "#D1D5DB",
  },
  "&:disabled": {
    opacity: 0.45,
    color: "#9CA3AF",
  },
};

export function CustomersPagination({ page, totalPages, onPrev, onNext }) {
  return (
    <div className="flex flex-col gap-4 border-t border-[#EFEFEF] pt-5 sm:flex-row sm:items-center sm:justify-between">
      <p className="my-0 text-[12px] font-medium tabular-nums text-[#9CA3AF]">
        Page {page} of {totalPages}
      </p>
      <div className="flex gap-2">
        <MaButton title="Previous" onClick={onPrev} disabled={page <= 1} sx={btnSx} />
        <MaButton
          title="Next"
          onClick={onNext}
          disabled={page >= totalPages}
          sx={btnSx}
        />
      </div>
    </div>
  );
}
